import { AxiosRequestConfig } from "axios";

import { unpackError } from "@dashboard/devices/api/helpers";
import { BaseQueryFn } from "@reduxjs/toolkit/query/react";
import HttpService from "@services/httpService";

type ApiError = { message: string };

export const baseQuery: BaseQueryFn<AxiosRequestConfig, ApiError> = async (arg) => {
    try {
        const resolvedArg = await Promise.resolve(arg);
        const response = await HttpService.axiosInstance.request(resolvedArg);
        return { data: response.data };
    } catch (err) {
        return { error: unpackError(err) };
    }
};
